import React from 'react'
import TreeFilter from 'components/TreeSelectFilter'

const StatusRoundFilter = ({filterOptions,filterValues,handleFilterChange,handleFilterSearch,stage}) => {
  return (
    <div style={{ display:'flex' , rowGap: '0px !important' }}>
    <TreeFilter
      span={12}
      width="95%"
      label="Round"
      placeholder="Select Round"
      treeData={filterOptions?.roundList}
      value={filterValues?.selectedRound}
      onChange={handleFilterChange}
      onSearch={handleFilterSearch}
      direction='column'
       valueKey='selectedRound'
       disable={stage != "all_candidates"}
       disabled={stage != "all_candidates"}
       maxSelectedCount={1}
    />
    <TreeFilter
      span={11}
      width="100%"
      label="Status"
      placeholder="Select Status"
      treeData={filterOptions?.statusList}
      value={filterValues?.selectedStatus}
      onChange={handleFilterChange}
      onSearch={handleFilterSearch}
      direction='column'
      valueKey='selectedStatus'
      disable={false}
      disabled={false}
    />
  </div>
  )
}

export default StatusRoundFilter